import { render, staticRenderFns } from "./ModalAddItem.vue?vue&type=template&id=60ccd3b1&"
import script from "./ModalAddItem.vue?vue&type=script&lang=js&"
export * from "./ModalAddItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports